export const env = {
  ACCOUNT_TOOL_URL: import.meta.env.VITE_ACCOUNT_TOOL_URL,
  AUTH_API_PATH: import.meta.env.VITE_AUTH_API_PATH,
  AUTH_MSENTRAID_CLIENT_ID: import.meta.env.VITE_AUTH_MSENTRAID_CLIENT_ID,
  AUTH_MSENTRAID_BFF_API_SCOPE: import.meta.env.VITE_AUTH_MSENTRAID_BFF_API_SCOPE,
  AUTH_MSENTRAID_POWERBI_READ_REPORTS_SCOPE: import.meta.env.VITE_AUTH_MSENTRAID_POWERBI_READ_REPORTS_SCOPE,
  DESTINATIONS_TOOL_BACKEND_BASE_URL: import.meta.env.VITE_DESTINATIONS_TOOL_BACKEND_BASE_URL,
  NEW_RELIC_ENABLED: import.meta.env.VITE_NEW_RELIC_ENABLED === 'true',
  NEW_RELIC_APPLICATION_ID: import.meta.env.VITE_NEW_RELIC_APPLICATION_ID,
  CONSOLE_DEBUG_ENABLED: import.meta.env.VITE_CONSOLE_DEBUG_ENABLED === 'true',
  EXCURSIONS_ENABLED: import.meta.env.VITE_EXCURSIONS_ENABLED === 'true',
  VISITING_HOURS_EXTRA_FIELDS_ENABLED: import.meta.env.VITE_VISITING_HOURS_EXTRA_FIELDS_ENABLED === 'true',
  DESTINATION_DATABASE_ENABLED: import.meta.env.VITE_DESTINATION_DATABASE_ENABLED === 'true',
  POWERBI__EMBEDDED_REPORTS_ENABLED: import.meta.env.VITE_POWERBI__EMBEDDED_REPORTS_ENABLED === 'true',
  POWERBI__EMBEDDED_REPORTS_USE_APP_OWNS_DATA: import.meta.env.VITE_POWERBI__EMBEDDED_REPORTS_USE_APP_OWNS_DATA === 'true',
}
